export const endpoints = {
  searchCodeMappings: (id: number) => `case/import/${id}/missingMappings`,
  postSearchSLValues: (id: number) => `importSet/${id}/knownMissingMappings`,
  importSetMapping: (id: number) => `importSet/${id}/mappings`,
  optionsCollection: (optionCollectionId: number) => `importSet/optionsCollection/${optionCollectionId}/search`,
  optionPath: (optionCollectionId: number, codeId: number) => `importSet/optionsCollection/${optionCollectionId}/code/${codeId}/path`,
  metadata: (id: number) => `importSet/optionsCollection/${id}/metadata`,
  codetablesAccess: 'optionsCollection/access',
  categoryOptions: (optionCollectionId: number) => `importSet/optionsCollection/${optionCollectionId}/category/options`
};
